module.exports = __webpack_public_path__ + "static/media/RR-Pride-1.401d0d5d.JPG";